import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import Shell from "./components/layout/Shell";
import { Order } from "./pages/Order";
import { Analytic } from "./pages/Analytic";
import { Team } from "./pages/Team";
import { Category } from "./pages/Category";
import { Customer } from "./pages/Customer";
import { Toaster } from "react-hot-toast";
import { PrivateRoute } from "./components/hoc/PrivateRoute";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { isAdminLoggedIn } from "./redux/actions";
import { ActivityLogs } from "./pages/Logs";
import { Country } from "./pages/shipping/Country";
import { Warehouse } from "./pages/shipping/Warehouse";
import { ShippingCompany } from "./pages/shipping/ShippingCompany";
import { Price } from "./pages/shipping/Price";
import { ShippingCategory } from "./pages/shipping/ShippingCategory";
import { Discount } from "./pages/Discount";
import { Payment } from "./pages/Payment";
import SegmentsPage from "./pages/campaign/Segments";
import CampaignsPage from "./pages/campaign/Campaigns";
import CategoriesPage from "./pages/campaign/Categories";
import ProductsPage from "./pages/campaign/Products";
import { DeliveryRequests } from "./pages/Delivery";
import { Shipment } from "./pages/Shipment";
import { ElevenCategories } from "./pages/eleven/Categories";
import { ElevenProducts } from "./pages/eleven/Products";
import { ElevenCarts } from "./pages/eleven/Carts";
import { ElevenPayments } from "./pages/eleven/Payments";
import { ElevenOrders } from "./pages/eleven/Orders";
import { AddProduct } from "./pages/eleven/AddProduct";

export default function App() {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!auth.authenticate) {
      dispatch(isAdminLoggedIn());
    }
  }, [dispatch, auth.authenticate]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <Shell />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="orders" element={<Order />} />
            <Route path="shipments" element={<Shipment />} />
            <Route path="delivery-requests" element={<DeliveryRequests />} />
            <Route path="categories" element={<Category />} />
            <Route path="discounts" element={<Discount />} />
            <Route path="discounts" element={<Discount />} />
            <Route path="payments" element={<Payment />} />
            <Route path="customers" element={<Customer />} />
            <Route path="analytics" element={<Analytic />} />
            <Route path="team" element={<Team />} />
            <Route path="logs" element={<ActivityLogs />} />

            {/* Eleven */}
            <Route path="/eleven/categories" element={<ElevenCategories />} />
            <Route path="/eleven/products" element={<ElevenProducts />} />
            <Route path="/eleven/products/new" element={<AddProduct />} />
            <Route path="/eleven/carts" element={<ElevenCarts />} />
            <Route path="/eleven/payments" element={<ElevenPayments />} />
            <Route path="/eleven/orders" element={<ElevenOrders />} />

            {/* Shipping */}
            <Route path="shipping/countries" element={<Country />} />
            <Route path="shipping/warehouses" element={<Warehouse />} />
            <Route path="shipping/companies" element={<ShippingCompany />} />
            <Route path="shipping/prices" element={<Price />} />
            <Route path="shipping/categories" element={<ShippingCategory />} />
            {/* Campaign */}
            <Route path="campaigns/all" element={<CampaignsPage />} />
            <Route path="campaigns/segments" element={<SegmentsPage />} />
            <Route path="campaigns/categories" element={<CategoriesPage />} />
            <Route path="campaigns/products" element={<ProductsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" reverseOrder={false} />
      </BrowserRouter>
    </div>
  );
}
